import { LOCALE_PARAM } from "@/constants/routes";

type TPath = `/:${typeof LOCALE_PARAM}?/${string}`;

type TPageSegment<Path extends string> =
  Path extends `/:${typeof LOCALE_PARAM}?/${infer Segment}` ? Segment : never;

export function getPagePathSegment<P extends TPath>(path: P): TPageSegment<P> {
  return path.slice(LOCALE_PARAM.length + 4) as TPageSegment<P>;
}
